import React from 'react';

export function getSafeTweetUrl(value) {
  if (typeof value !== 'string' || value !== value.trim()) return null;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' ||
      !['x.com', 'www.x.com', 'twitter.com', 'www.twitter.com'].includes(url.hostname.toLowerCase()) ||
      url.port || url.username || url.password ||
      !/^\/[A-Za-z0-9_]{1,15}\/status\/\d+\/?$/.test(url.pathname)) return null;
    return url.href;
  } catch {
    return null;
  }
}

export function formatTimestamp(value) {
  if (!value) return 'Not recorded';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Not recorded';
  return date.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short', timeZoneName: undefined });
}

function PostLink({ url }) {
  const safeUrl = getSafeTweetUrl(url);
  return safeUrl
    ? <a href={safeUrl} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--gold)', overflowWrap: 'anywhere' }}>{safeUrl}</a>
    : <span>Post URL unavailable</span>;
}

export default function SubmissionReceipt({ receipt, status, padding = 24 }) {
  if (!receipt) return null;
  const history = receipt.history || [];
  const original = history[0];
  return (
    <section className="brief-section submission-receipt" aria-label="Your submission receipt" style={{ padding }}>
      <div className="brief-section-title">Your Submission Receipt</div>
      {status && <p className="submit-status-text">{status}</p>}
      <div className="brief-section-body">
        {receipt.id && <p>Receipt: <span style={{ overflowWrap: 'anywhere' }}>{receipt.id}</span></p>}
        <p>Current post: <PostLink url={receipt.url} /></p>
        <p>Submitted: {formatTimestamp(receipt.submittedAt)} (your local time)</p>
        {original && <p>Original post: <PostLink url={original.url} /></p>}
        {history.length > 0 && (
          <details>
            <summary>Replacement history ({history.length})</summary>
            <ol>
              {history.map((entry, index) => (
                <li key={`${entry.tweetId || entry.url}-${index}`}>
                  <PostLink url={entry.url} />
                  <div>Submitted: {formatTimestamp(entry.submittedAt)} · Replaced: {formatTimestamp(entry.replacedAt)}</div>
                </li>
              ))}
            </ol>
          </details>
        )}
      </div>
    </section>
  );
}
